module.exports = __webpack_public_path__ + "static/media/sCond.2ff8b014.png";